export default function Eye({
  onClick,
  addClassStyles,
}: {
  onClick?: () => any;
  addClassStyles?: string;
}) {
  return (
    <svg
      onClick={onClick}
      className={addClassStyles}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16924 7.91354C1.71619 8.63215 2.577 9.59349 3.67119 10.4043C4.90898 11.3215 6.38115 12 7.99994 12C9.61197 12 11.0786 11.3272 12.3134 10.4156C13.3949 9.61715 14.2499 8.67027 14.8009 7.95242C13.6573 6.25693 11.1355 4 7.99994 4C4.76439 4 2.24315 6.07319 1.16924 7.91354ZM15.8278 8.24697C14.6851 9.83804 11.7918 13 7.99994 13C4.19222 13 1.29068 9.81163 0.157905 8.22715C0.0571876 8.08628 0.0416244 7.90371 0.120067 7.74932C1.22501 5.57452 4.14906 3 7.99994 3C11.8171 3 14.7236 5.86698 15.8504 7.73841C15.9464 7.89785 15.9363 8.09581 15.8278 8.24697Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99994 10C9.10451 10 9.99994 9.10457 9.99994 8C9.99994 6.89543 9.10451 6 7.99994 6C6.89537 6 5.99994 6.89543 5.99994 8C5.99994 9.10457 6.89537 10 7.99994 10ZM7.99994 11C9.65679 11 10.9999 9.65685 10.9999 8C10.9999 6.34315 9.65679 5 7.99994 5C6.34308 5 4.99994 6.34315 4.99994 8C4.99994 9.65685 6.34308 11 7.99994 11Z"
        fill="black"
      />
    </svg>
  );
}
